import { API_PREFIX } from '../../../shared/constants';
import { createRestClient, assertStatusCode } from '../../shared/rest';
import { Campaign } from '@pegasus/types/campaign';

export interface Response {
    results: Campaign[];
}

export const fetchOpenCampaigns = (): Promise<Response> => {
    const client = createRestClient(API_PREFIX, false);

    return client
        .get(`/open-campaigns`)
        .then(assertStatusCode([200]))
        .then(response => response.json())
        .then(data => ({
            results: data,
        }));
};
